
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talcum.claims",
      function () {
        return require("private-next-pages/talcum.claims/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talcum.claims"])
      });
    }
  